import {inject, Injectable} from '@angular/core';
import {ProductCardData} from "../../../../types/product-card-data.types";
import {SyncProductCard} from "../types/product-card-sync-modal.types";
import {ProductCardSyncApiService} from "./product-card-sync-api.service";
import {RecordsDataRequestQueryParams} from "../../../../../../../core/types/records-table.types";

@Injectable({
  providedIn: 'root'
})
export class ProductCardSyncService {
  private productCardSyncApiService: ProductCardSyncApiService = inject(ProductCardSyncApiService);

  public fetchProductCardsList(queryParams: RecordsDataRequestQueryParams): Promise<Array<ProductCardData>> {
    return new Promise((resolve, reject) => {
      this.productCardSyncApiService.fetchProductCardsList(queryParams).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public fetchSyncProductCardsList(queryParams: RecordsDataRequestQueryParams): Promise<Array<ProductCardData>> {
    return new Promise((resolve, reject) => {
      this.productCardSyncApiService.fetchSyncProductCardsList(queryParams).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public attachProductCard(syncProductCard :SyncProductCard): Promise<void> {
    return new Promise((resolve, reject) => {
      this.productCardSyncApiService.attachProductCard(syncProductCard).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      });
    });
  }

  public detachProductCard(syncProductCard :SyncProductCard): Promise<void> {
    return new Promise((resolve, reject) => {
      this.productCardSyncApiService.detachProductCard(syncProductCard).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      });
    });
  }
}
